import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"width":"100%","height":"400px"} }
const _hoisted_4 = { class: "legend-item" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "legend-item"
}
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bar = _resolveComponent("Bar")!

  return (_ctx.matchingLocations != null && _ctx.matchingLocations.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.location)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.location.name), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Bar, {
            options: _ctx.chartOptions,
            data: _ctx.chartData
          }, null, 8, ["options", "data"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "legend-color",
              style: _normalizeStyle({ background: 'linear-gradient(to right,' + this.matchingColors.join(',') + ')' })
            }, null, 4),
            _createElementVNode("span", {
              innerHTML: _ctx.removeMdiBracketToIcon(this.matchingLocations[0].outputLocationPropertyTitle)
            }, null, 8, _hoisted_5)
          ]),
          (this.matchingLocations[0].actualOutputLocationPropertyValue != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[0] || (_cache[0] = _createElementVNode("div", {
                  class: "legend-color",
                  style: {"background-color":"#cccccc"}
                }, null, -1)),
                _createElementVNode("span", {
                  innerHTML: _ctx.removeMdiBracketToIcon(this.matchingLocations[0].actualOutputLocationPropertyTitle)
                }, null, 8, _hoisted_7)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}